export default function authHeader() {
    let user = JSON.parse(localStorage.getItem('api_token'));
 
    if (user && user.user.api_token) { 
      return { Authorization: 'Bearer ' + user.user.api_token };
    } else {
      return {};
    }
  }